import { useMutation } from "@tanstack/react-query";
import { updateGameStatus } from "../api/updateGameStatus";
import { invalidateGameDetailsQuery } from "./useGameDetailsQuery";
import { UpdateStatusParams } from "../types";
import { useRefreshAlgoliaData } from "entities/algolia/hooks/useRefreshAlgoliaData";

const INITIAL_DELAY_MS = 2000;
const REFRESH_INTERVAL_MS = 5000;

export const useUpdateGameStatusQuery = () => {
  const { refreshAlgoliaData } = useRefreshAlgoliaData();

  return useMutation({
    mutationFn: async ({ gameId, status }: UpdateStatusParams) => {
      return await updateGameStatus(gameId, status);
    },
    onSuccess: (_, variables) => {
      // Invalidate query and refetch Algolia
      invalidateGameDetailsQuery(variables.gameId);
      refreshAlgoliaData(INITIAL_DELAY_MS);
      refreshAlgoliaData(REFRESH_INTERVAL_MS);
    },
  });
};
